import queryString from 'query-string'

const REMOTE = 'rem_vvis'
const VISITOR_APP = 'visitor_app'

export function isRemoteVisitor() {
  const queryParams = queryString.parse(location.hash.split('?')[1])

  const {
    user_id: userId,
    visitor_id: visitorId,
    type: visitType,
    device_type: deviceType,
  } = queryParams

  const isRemoteVisitor = visitType === REMOTE && userId === visitorId || deviceType === VISITOR_APP
  return isRemoteVisitor || isIOS()
}

export function isIOS() {
  return ['iPhone', 'iPad'].some(function (iOS) {
    return window.navigator.userAgent.includes(iOS)
  })
}

export function isAndroid() {
  return window.navigator.userAgent.includes('Android')
}
